( function( $ ) {
    //read more function to reveal text
    $('.text-read-toggle').on('click', function() {
        var contentWrap = $(this).parents('.text-read-content-wrapper');
        var shortContent = contentWrap.find('.text-read-short-content');
        var completeContent = contentWrap.find('.text-read-complete-content');

        if($(this).hasClass('text-read-more')) {
            shortContent.hide();
            completeContent.show();
        }

        if($(this).hasClass('text-read-less')) {
            completeContent.hide();
            shortContent.show();
        }
    });
} )( jQuery );
